import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../user.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.css']
  
})
export class ResetComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private auth: UserService,
    public router:Router,
  ) { }

  //@ts-ignore
  loginForm: FormGroup;
  submitted: boolean = false;
  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '[a-zA-Z0-9.-_+]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ]),
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }
  message: any;
  isFormSubmitting: boolean = false;
  isError: boolean = false;
  async forgetPassword() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    console.log(this.loginForm.value.email);
    
    this.isFormSubmitting = true;
    this.isError = false;
    this.message = '';
    
    try {
      await this.auth.forgetPassword(this.loginForm.value.email);
      this.message = 'Password reset email sent. Please check your inbox.';
      setTimeout(() => {
        this.router.navigateByUrl("/login");
      }, 3000);
    } catch (error: any) {
      this.isError = true;
      this.message = error.message || 'Failed to send password reset email. Please try again.';
      console.error('Password reset error:', error);
    } finally {
      this.isFormSubmitting = false;
    }
  }

  closeModal() { }
}